import { defineStyleConfig } from '@chakra-ui/react';

export const SelectStyle = defineStyleConfig({
  sizes: {
    lg: {
      field: {
        fontSize: 'md',
        h: '62px',
      },
    },
    md: {
      field: {
        fontSize: 'md',
        h: '46px',
      },
    },
  },
});
